/**
 * Created by Shikha on 2021-04-22.
 */

import {TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HorribleHeroesGameModuleConfig} from "../HorribleHeroesGameModuleConfig";
import {HorribleHeroesParsedGameData} from "../server/data/HorribleHeroesParsedGameData";
import {HorribleHeroesParsedInitData} from "../server/data/HorribleHeroesParsedInitData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";


export class MayhemModeIntroPresentation implements GameRoundPresentation {

    /**
     * @constructs
     * @param stagger
     * @param abortStagger
     */
    constructor() {
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: HorribleHeroesParsedGameData | HorribleHeroesParsedInitData): TimelineLite | null {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                tl.pause();
                tl.kill();
                tl.clear();
            }
        });
        if (data.superFSTriggered || this.checkScattersCollected(data)) {
            tl.add(HorribleHeroesGameModuleConfig.mayHemModeIntro.playAnimation(data.superFSTriggered));
            SlotGame.keypad.setZeroBetSpinCounter(data.freespinsLeft);
            //#447
        }
        return tl;
    }

    /*fS Intro pick Screen
    * for restore and as normal*/
    private checkScattersCollected(data: HorribleHeroesParsedGameData | HorribleHeroesParsedInitData): boolean {
        return ((data.mode.indexOf("PICK") > -1 && data.getScattersCollected > 4));
    }
}